import { IconProps } from './IconProps'

export function InitialTierIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z'
        fill='white'
        stroke='#EBEFF6'
      />
      <g clipPath='url(#clip0_2391_50066)'>
        <path
          d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
          fill='#B3C5E0'
        />
        <path
          d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
          fill='#B3C5E0'
        />
      </g>
      <defs>
        <clipPath id='clip0_2391_50066'>
          <rect width='26.2081' height='30' fill='white' transform='translate(10.8965 9)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function BronzeQuarterIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z'
        fill='white'
        stroke='#EBEFF6'
      />
      <g clipPath='url(#clip0_3189_16718)'>
        <path
          d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
          fill='#B3C5E0'
        />
        <path
          d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
          fill='#B3C5E0'
        />
        <mask
          id='mask0_3189_16718'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='10'
          y='9'
          width='28'
          height='30'
        >
          <path
            d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
            fill='#BAC3D1'
          />
          <path
            d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
            fill='#BAC3D1'
          />
        </mask>
        <g mask='url(#mask0_3189_16718)'>
          <rect x='23.9219' y='9' width='13.1831' height='15.1758' fill='#F70121' />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_3189_16718'>
          <rect width='26.2081' height='30' fill='white' transform='translate(10.8965 9)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function BronzeHalfIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z'
        fill='white'
        stroke='#EBEFF6'
      />
      <g clipPath='url(#clip0_2983_18016)'>
        <path
          d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
          fill='#B3C5E0'
        />
        <path
          d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
          fill='#B3C5E0'
        />
        <mask
          id='mask0_2983_18016'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='10'
          y='9'
          width='28'
          height='30'
        >
          <path
            d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
            fill='#BAC3D1'
          />
          <path
            d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
            fill='#BAC3D1'
          />
        </mask>
        <g mask='url(#mask0_2983_18016)'>
          <rect x='23.9219' y='8.99414' width='13.1831' height='30.0059' fill='#F70121' />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_2983_18016'>
          <rect width='26.2081' height='30' fill='white' transform='translate(10.8965 9)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function BronzeThreeQuarterIcon(props: IconProps): JSX.Element {
  const size = props.size || 48

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z'
        fill='white'
        stroke='#EBEFF6'
      />
      <g clipPath='url(#clip0_2983_18027)'>
        <path
          d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
          fill='#B3C5E0'
        />
        <path
          d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
          fill='#B3C5E0'
        />
        <mask
          id='mask0_2983_18027'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='10'
          y='9'
          width='28'
          height='30'
        >
          <path
            d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
            fill='#BAC3D1'
          />
          <path
            d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
            fill='#BAC3D1'
          />
        </mask>
        <g mask='url(#mask0_2983_18027)'>
          <rect x='10.8184' y='23.8242' width='13.1831' height='15.1758' fill='#F70121' />
          <rect x='23.9219' y='8.99414' width='13.1831' height='30.0059' fill='#F70121' />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_2983_18027'>
          <rect width='26.2081' height='30' fill='white' transform='translate(10.8965 9)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function BronzeIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#FF6D2E'
      />
      <path
        d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
        fill='white'
      />
      <path
        d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
        fill='white'
      />
    </svg>
  )
}

export function SilverIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#B3C5E0'
      />
      <path
        d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
        fill='white'
      />
      <path
        d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
        fill='white'
      />
    </svg>
  )
}

export function GoldIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#FFD60B'
      />
      <path
        d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
        fill='white'
      />
      <path
        d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
        fill='white'
      />
    </svg>
  )
}

export function PlatinumIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#7A899F'
      />
      <path
        d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
        fill='white'
      />
      <path
        d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
        fill='white'
      />
    </svg>
  )
}

export function DiamondIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#E81AFF'
      />
      <path
        d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
        fill='white'
      />
      <path
        d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
        fill='white'
      />
    </svg>
  )
}

export function EliteIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#6A14FF'
      />
      <path
        d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
        fill='white'
      />
      <path
        d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
        fill='white'
      />
    </svg>
  )
}

export function ElitePlusIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#5500DD'
      />
      <path
        d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
        fill='white'
      />
      <path
        d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
        fill='white'
      />
    </svg>
  )
}

export function LegendIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#FF0544'
      />
      <path
        d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
        fill='white'
      />
      <path
        d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
        fill='white'
      />
    </svg>
  )
}

export function UltimateIcon(props: IconProps): JSX.Element {
  const { className } = props
  const size = props.size || 48
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#04142A'
      />
      <path
        d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
        fill='white'
      />
      <path
        d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
        fill='white'
      />
    </svg>
  )
}

export function UltraIcon(props: IconProps): JSX.Element {
  const size = props.size || 48
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='#9C0034'
      />
      <path
        d='M17.6732 20.332C17.5865 20.4826 17.5363 20.6513 17.5265 20.8247V26.3222L10.8965 30.1358V17.7463C10.9184 17.3121 11.0411 16.8889 11.2548 16.5101C11.4685 16.1314 11.7675 15.8074 12.1281 15.5638L22.7827 9.29571C23.1593 9.1014 23.577 9 24.0008 9C24.4247 9 24.8424 9.1014 25.2189 9.29571L35.8717 15.5657C35.9239 15.5969 35.9736 15.6319 36.0205 15.6706L29.2771 19.5528L24.4986 16.7827C24.3441 16.7043 24.1732 16.6634 23.9999 16.6634C23.8266 16.6634 23.6557 16.7043 23.5012 16.7827L18.0256 19.9576C17.8805 20.0533 17.7598 20.1815 17.6732 20.332Z'
        fill='white'
      />
      <path
        d='M30.4746 27.1753V21.6815L37.1046 17.8632V30.2528C37.0827 30.687 36.96 31.1102 36.7463 31.4889C36.5325 31.8677 36.2336 32.1917 35.873 32.4353L25.2193 38.7043C24.8427 38.8986 24.425 39 24.0012 39C23.5773 39 23.1596 38.8986 22.7831 38.7043L12.1293 32.4353C12.078 32.4028 12.0284 32.3678 11.9806 32.3304L18.7194 28.4481L23.5016 31.2182C23.6561 31.2967 23.8269 31.3375 24.0002 31.3375C24.1736 31.3375 24.3444 31.2967 24.4989 31.2182L29.9754 28.0433C30.1207 27.9476 30.2414 27.8192 30.3281 27.6685C30.4148 27.5178 30.4649 27.3489 30.4746 27.1753Z'
        fill='white'
      />
    </svg>
  )
}
